export default __webpack_public_path__ + "static/media/ci-ejemplo.2b357a71.jpg";